import type { ReactNode } from 'react';

export const symbol_motorcycle: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M447-540H343h213-109ZM200-200q-83 0-141.5-58.5T0-400q0-83 58.5-141.5T200-600h474L574-700H453q-13 0-21.5-8.5T423-730q0-13 8.5-21.5T453-760h121q12 0 23.5 5t19.5 13l142 142q90 0 145.5 61T960-400q0 83-58.5 141.5T760-200q-83 0-141.5-58.5T560-400q0-18 2.5-35.5T572-470L471-369q-5 5-10 7t-11 2h-54q-14 70-69 115t-127 45Zm560-60q58 0 99-41t41-99q0-58-41-99t-99-41q-58 0-99 41t-41 99q0 58 41 99t99 41Zm-560 0q45 0 84-28t53-82h-87q-13 0-21.5-8.5T220-400q0-13 8.5-21.5T250-430h87q-14-54-53-82t-84-28q-58 0-99 41t-41 99q0 58 41 99t99 41Zm198-170h49l109-110H343q20 20 35 48.5t20 61.5Z"
		/>
	</svg>
);
